import { useState } from "react";

/**
 * Logo do sistema (símbolo do corredor — public/logo/) + logomarca (wordmark).
 * O wordmark usa public/brand/logomarca.png quando existir; sem o arquivo,
 * cai no fallback tipográfico. O símbolo cai na recriação vetorial (SVG).
 */
/** Recriação vetorial do símbolo do corredor (usada até o logo.png existir). */
function RunnerMark({ size }) {
  return (
    <svg viewBox="0 0 120 120" width={size} height={size} className="shrink-0" aria-label="Ortopédica São Paulo">
      <defs>
        <linearGradient id="osp-navy" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#15335C" /><stop offset="1" stopColor="#0B2038" />
        </linearGradient>
        <linearGradient id="osp-teal" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#1976D2" /><stop offset="1" stopColor="#14B8A6" />
        </linearGradient>
      </defs>
      {/* arco envolvente */}
      <path d="M 84.7 21 A 50 50 0 1 0 66.4 110.9" fill="none" stroke="url(#osp-navy)" strokeWidth="9.5" strokeLinecap="round" />
      {/* cabeça */}
      <circle cx="72" cy="25" r="9" fill="url(#osp-navy)" />
      {/* braço frontal */}
      <path d="M 62 36 Q 76 30 90 36 Q 78 44 64 44 Z" fill="url(#osp-teal)" />
      {/* braço traseiro */}
      <path d="M 58 36 Q 44 38 38 50 Q 50 48 59 42 Z" fill="url(#osp-navy)" />
      {/* tronco + perna traseira */}
      <path d="M 64 46 Q 60 62 46 74 Q 38 80 33 91 Q 50 85 60 71 Q 67 61 69 50 Z" fill="url(#osp-navy)" />
      {/* perna frontal */}
      <path d="M 68 54 Q 76 66 89 69 Q 96 71 101 79 Q 86 82 75 74 Q 67 66 64 58 Z" fill="url(#osp-teal)" />
      {/* coluna de esferas */}
      <circle cx="59" cy="42" r="4" fill="#14B8A6" />
      <circle cx="56" cy="50" r="3.6" fill="#14B8A6" />
      <circle cx="53" cy="58" r="3.2" fill="#14B8A6" />
      <circle cx="50" cy="65" r="2.7" fill="#14B8A6" />
      <circle cx="47.5" cy="72" r="2.2" fill="#14B8A6" />
      <circle cx="45" cy="78" r="1.8" fill="#14B8A6" />
    </svg>
  );
}

export function LogoMark({ size = 36, className = "" }) {
  const [broken, setBroken] = useState(false);
  if (broken) {
    return <RunnerMark size={size} />;
  }
  return (
    <img src="/logo/logo_256x256.png" alt="Ortopédica São Paulo" width={size} height={size}
      className={`object-contain shrink-0 ${className}`} style={{ width: size, height: size }}
      onError={() => setBroken(true)} />
  );
}

export function LogoType({ height = 26, className = "", light = false }) {
  const [broken, setBroken] = useState(false);
  if (broken) {
    return (
      <span className={`font-heading font-bold leading-none tracking-tight ${className}`} style={{ fontSize: height * 0.62 }}>
        <span className={light ? "text-white" : "text-[#0B2038]"}>ORTOPÉDICA</span>{" "}
        <span className="text-brand-500">SÃO PAULO</span>
      </span>
    );
  }
  return (
    <img src="/brand/logomarca.png" alt="Ortopédica São Paulo — Cuidar, Reabilitar, Transformar"
      style={{ height }} className={`object-contain ${className}`}
      onError={() => setBroken(true)} />
  );
}

export default function BrandLogo({ size = 38, typeHeight = 24, light = false, className = "" }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <LogoType height={typeHeight} light={light} />
    </span>
  );
}
